import { FC, useRef, useCallback } from "react";
import {
  ChatInput,
  ChatInputHandle,
  ChatInputParams,
} from "@web-src/modules/chats/components/ChatInput";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useClientSupportPageContext } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageContext";

export const TwilioChatInput: FC<{
  chatId: string;
  onMessageSent?: () => void;
}> = ({ chatId, onMessageSent }) => {
  const { setIsSendingMessage } = useClientSupportPageContext();
  const { entityId } = useEntitySelectedProvider();
  const { integrationsApi } = useRestApiProvider();
  const [sendTwilioMessage] = integrationsApi.useSendTwilioMessageMutation();
  const chatInput$ = useRef<ChatInputHandle>(null);

  const handleSendMessage: ChatInputParams["onSubmit"] = useCallback(
    async ({ body }) => {
      if (!body.trim()) return;

      try {
        setIsSendingMessage(true);

        await sendTwilioMessage({
          entityId,
          data: {
            to: chatId,
            body: body.trim(),
          },
        }).unwrap();

        setTimeout(() => {
          chatInput$.current?.setValue("");
        }, 100);
        chatInput$.current?.focus();
        onMessageSent?.();
      } catch (error) {
        // NOTE: pass
      } finally {
        setIsSendingMessage(false);
      }
    },
    [chatId, entityId, sendTwilioMessage, onMessageSent, setIsSendingMessage]
  );

  return (
    <div className="px-8 pb-1.5 pt-[18px]">
      <ChatInput
        id={chatId}
        ref={chatInput$}
        onSubmit={handleSendMessage}
        isLoading={false}
        toolbarActions={{
          emoji: {
            enabled: true,
          },
          attachments: {
            enabled: false,
          },
        }}
      />
    </div>
  );
};
